// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LY5M","icon":"styles_icon__Ws3EJ"};